import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FactorStrategy } from 'src/app/models/factor-strategy.model';

@Component({
  selector: 'app-portfolio-models-factor-analysis',
  templateUrl: './portfolio-models-factor-analysis.component.html',
  styleUrls: ['./portfolio-models-factor-analysis.component.scss']
})
export class PortfolioModelsFactorAnalysisComponent implements OnInit {

  @Input() strategy1: FactorStrategy;
  @Input() strategy2: FactorStrategy;
  @Input() strategy3: FactorStrategy;

  @Input() inceptionDate: Date;
  @Input() lastDate: Date;

  selectedPage: string = 'styleBox';
  selectedTabTab: string = 'Exposure';
  selectedTab: string = 'deconcentration';
  selectedType: string;
  selectedIndex: number;

  styleBoxData: any;

  constructor() { }

  ngOnInit(): void {
    this.computeStyleBoxData();
  }

  onTabChangeTab(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Exposure':        this.selectedTabTab='Exposure'; break;
      case 'Rating':          this.selectedTabTab='Rating'; break;
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTab = ['deconcentration', 'diversification'][event.index];
  }

  onSelectedPeerChange(event) {
    this.selectedType = event.type;
    this.selectedIndex = event.index ? event.index : this.selectedIndex;
  }

  computeRankings(strategy: FactorStrategy) {
    return {
      factor_deconcentration: {
        nb_analysis: strategy.factorAnalysis.rankings.factor_deconcentration_quality.nb_analysis_factor_deconcentration_quality,
        rank: strategy.factorAnalysis.rankings.factor_deconcentration_quality.rank_factor_deconcentration_quality,
        rating: strategy.factorAnalysis.diversification.factor_deconcentration_quality_rating
      },
      factor_diversification: {
        nb_analysis: strategy.factorAnalysis.rankings.factor_diversification_quality.nb_analysis_factor_diversification_quality,
        rank: strategy.factorAnalysis.rankings.factor_diversification_quality.rank_factor_diversification_quality,
        rating: strategy.factorAnalysis.diversification.factor_diversification_quality_rating
      }
    }
  }

  computeStyleBoxData() {
    this.styleBoxData = {
      default1: this.computeRankings(this.strategy1),
      default2: this.computeRankings(this.strategy2),
      default3: this.computeRankings(this.strategy3)
    }
  }

}
